/* RESPONSIBLE TEAM: team-ai-agent */
import ProceduresIndexRoute from 'embercom/routes/apps/app/automation/fin-ai-agent/procedures/index';

export default class FinAiAgentEcommerceProceduresIndexRoute extends ProceduresIndexRoute {
  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.ecommerce.procedures',
  };
}
